import React from "react";
import { Dropdown } from "antd";
import { UpOutlined } from "@ant-design/icons";
import style from "./style.module.scss";

const Btn = (props: any) => {
  const {
    icon,
    dropdown,
    children,
    onClick,
    style: containerStyle,
    hover = true,
  } = props;

  return (
    <span className={style.container} style={containerStyle}>
      <div className={style.btn} onClick={onClick}>
        <div className={style.icon}>{icon}</div>
        <div className={style.name}>{children}</div>
      </div>
      {dropdown && (
        <Dropdown
          overlay={dropdown}
          placement="topCenter"
          trigger={hover ? ["hover"] : ["click"]}
        >
          <span className={style.suffix} onClick={(e) => e.stopPropagation()}>
            <UpOutlined />
          </span>
        </Dropdown>
      )}
    </span>
  );
};
export default Btn;
